<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-01 11:39:22
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-11-01 17:38:10
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\tableCells\ButtonsCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex">
		<el-button v-for="(item, index) in cellValue" type="text" :key="index" @click="click(item)" :class="{ default: item.class }">
			{{ item.label }}
		</el-button>
	</div>
</template>
<script>
export default {
	props: {
		column: {
			type: Object,
			default: () => {
				return {};
			},
		},
		row: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	computed: {
		cellValue() {
			const val = this.row[this.column.key];
			return val || '';
		},
	},
	data() {
		return {};
	},
	methods: {
		click({ click }) {
			click && click(this.row);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .default {
	color: #4e596a;
}
/deep/ .el-button--small {
	font-size: 13px;
}
</style>
